import { AtHeader, AtDropdown } from '@/components/atoms';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { MlInfoTooltip } from '@/components/molecules/ml-info-tooltip/ml-info-tooltip';
import { IControlInputProps } from './types';

export const ExteriorAndPriceSelects = ({
  configMap,
  filterValues,
  setFilter,
  hasLocation,
  tooltipText,
  setWereFiltersUsed,
}: IControlInputProps) => {
  if (!configMap) return null;

  const isMultiExterior = configMap['ExteriorStyle']?.multi || false;

  const rawValueExterior = filterValues['ExteriorStyle'];
  const exteriorValue: string | string[] = isMultiExterior
    ? Array.isArray(rawValueExterior)
      ? rawValueExterior.filter((v): v is string => typeof v === 'string') // type guard: keep only strings
      : typeof rawValueExterior === 'string'
        ? [rawValueExterior]
        : []
    : typeof rawValueExterior === 'string'
      ? rawValueExterior
      : '';

  const isMultiPrice = configMap['Price']?.multi || false;

  const rawValuePrice = filterValues['Price'];
  const priceValue: string | string[] = isMultiPrice
    ? Array.isArray(rawValuePrice)
      ? rawValuePrice.filter((v): v is string => typeof v === 'string') // type guard: keep only strings
      : typeof rawValuePrice === 'string'
        ? [rawValuePrice]
        : []
    : typeof rawValuePrice === 'string'
      ? rawValuePrice
      : '';

  return (
    <div className="mt-5 grid grid-cols-1 gap-3 md:mt-0 lg:grid-cols-2">
      <div>
        <AtHeader className="mb-4" variant="h6">
          Choose an Exterior
        </AtHeader>
        <AtDropdown
          backgroundColor={
            exteriorValue.length > 0 ? 'bg-skin-primary' : 'bg-transparent'
          }
          isMulti={isMultiExterior}
          hasBorder
          icon={EIcons.EXTERIOR}
          label="All Styles"
          options={configMap['ExteriorStyle']?.options ?? []}
          value={exteriorValue}
          onChange={(val) => {
            const newValues = Array.isArray(val) ? val : [val];
            setFilter('ExteriorStyle', newValues);
            setWereFiltersUsed(true);
          }}
        />
      </div>

      {hasLocation && (
        <div className="mt-3 md:mt-0">
          <span className="flex gap-2">
            <AtHeader className="mb-4" variant="h6">
              Price Range
            </AtHeader>
            {tooltipText && (
              <MlInfoTooltip iconName={EIcons.INFO} body={tooltipText} />
            )}
          </span>
          <AtDropdown
            hasBorder
            isMulti={isMultiPrice}
            backgroundColor={
              filterValues['Price'] ? 'bg-skin-primary' : 'bg-transparent'
            }
            icon={EIcons.PRICE}
            label="Price"
            options={configMap['Price']?.options ?? []}
            value={priceValue}
            onChange={(val) => {
              const newValues = Array.isArray(val) ? val : [val];
              setFilter('Price', newValues);
              setWereFiltersUsed(true);
            }}
          />
        </div>
      )}
    </div>
  );
};
